"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pushToDataLayerStepSuccess = exports.pushToDataLayerSendForm = exports.pushToDataLayerRequiredValidField = exports.pushToDataLayerOnce = exports.pushToDataLayerLoadedStep = exports.pushToDataLayerInvalidField = exports.pushToDataLayerFormSuccess = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _pushToDataLayer2 = _interopRequireDefault(require("./pushToDataLayer"));
const _excluded = ["time", "eventLabel"];

//
// eslint-disable-next-line no-underscore-dangle
function _pushToDataLayer(_ref) {
  var _window, _window$location;
  let {
      time = Date.now(),
      eventLabel = (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname
    } = _ref,
    data = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  (0, _pushToDataLayer2.default)(Object.assign({
    time,
    eventLabel
  }, data));
}
const pushToDataLayerLoadedStep = name => {
  _pushToDataLayer({
    event: "GAFormEvent",
    eventCategory: "stepLoaded",
    eventAction: name,
    time: Date.now()
  });
};
exports.pushToDataLayerLoadedStep = pushToDataLayerLoadedStep;
const pushToDataLayerInvalidField = function (fieldKey, reason) {
  let eventAttempt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  _pushToDataLayer({
    event: "GAFormEvent",
    eventCategory: "invalidField",
    eventAction: `${fieldKey} - ${typeof reason === "object" ? JSON.stringify(reason) : reason}`,
    focus: "onfocus",
    time: Date.now(),
    eventAttempt
  });
};
exports.pushToDataLayerInvalidField = pushToDataLayerInvalidField;
const pushToDataLayerSendForm = () => {
  var _window2, _window2$location;
  _pushToDataLayer({
    event: "GAFormEvent",
    eventCategory: "sendForm",
    eventAction: (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.pathname,
    focus: "onfocus",
    time: Date.now()
  });
};
exports.pushToDataLayerSendForm = pushToDataLayerSendForm;
const pushToDataLayerRequiredValidField = fieldKey => {
  _pushToDataLayer({
    event: "GAFormEvent",
    eventCategory: "validateField",
    eventAction: fieldKey,
    focus: "onfocus",
    time: Date.now()
  });
};
exports.pushToDataLayerRequiredValidField = pushToDataLayerRequiredValidField;
const pushToDataLayerStepSuccess = (name, placement) => {
  const data = {
    event: "GAFormEvent",
    eventCategory: "stepSuccess",
    eventAction: name,
    time: Date.now()
  };
  if (placement !== undefined) {
    data.placement = placement;
  }
  _pushToDataLayer(data);
};
exports.pushToDataLayerStepSuccess = pushToDataLayerStepSuccess;
const pushToDataLayerFormSuccess = () => {
  var _window3, _window3$location;
  _pushToDataLayer({
    event: "GAFormEvent",
    eventCategory: "formSuccess",
    eventAction: (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$location = _window3.location) === null || _window3$location === void 0 ? void 0 : _window3$location.pathname,
    time: Date.now()
  });
};
exports.pushToDataLayerFormSuccess = pushToDataLayerFormSuccess;
const pushToDataLayerOnce = (() => {
  const executedEvents = {}; // eslint-disable-next-line func-names

  return function (eventName, eventData) {
    // Проверяем, было ли событие уже выполнено
    if (!executedEvents[eventName]) {
      executedEvents[eventName] = [eventData];
      (0, _pushToDataLayer2.default)(eventData);
      return;
    }
    const isPlacementRepeated = executedEvents[eventName].some(executedEvent => executedEvent.placement === eventData.placement); // Если placement уникален, добавляем событие и пушим его в DataLayer

    if (!isPlacementRepeated) {
      executedEvents[eventName].push(eventData);
      (0, _pushToDataLayer2.default)(eventData);
    }
  };
})();
exports.pushToDataLayerOnce = pushToDataLayerOnce;